// Kommentare des offenen Projekts: einmal laden, alle 15 s nachladen, solange ein Kommentarbereich sichtbar ist.
// Eigene Änderungen werden sofort eingearbeitet, ohne auf das Nachladen zu warten.
import { useEffect, useSyncExternalStore } from 'react';
import { api, type BezugTyp, type Kommentar } from './api';
import { useNachladen } from './ui/nachladen';

const NACHLADEN_MS = 15_000;

let projekt = '';
let liste: Kommentar[] = [];
let stand = 0;
let laeuft: Promise<void> | null = null;
const listeners = new Set<() => void>();
const melden = () => { stand++; for (const l of listeners) l(); };
const abonnieren = (fn: () => void) => (listeners.add(fn), () => void listeners.delete(fn));

export function kommentareLaden(projektId: string): Promise<void> {
  if (projektId !== projekt) { projekt = projektId; liste = []; laeuft = null; melden(); }
  laeuft ??= api.kommentare(projektId)
    .then((l) => { if (projekt === projektId) { liste = l; melden(); } })
    .catch(() => { /* Nachladen versucht es erneut */ })
    .finally(() => { laeuft = null; });
  return laeuft;
}

export function kommentarEintragen(k: Kommentar) {
  liste = [...liste.filter((x) => x.id !== k.id), k];
  melden();
}

export function kommentarEntfernen(id: string) {
  liste = liste.filter((x) => x.id !== id);
  melden();
}

/** Alle Kommentare des Projekts; lädt nach, solange die Komponente sichtbar ist. */
export function useAlleKommentare(projektId: string): Kommentar[] {
  useSyncExternalStore(abonnieren, () => stand);
  useEffect(() => {
    void kommentareLaden(projektId);
  }, [projektId]);
  useNachladen(() => void kommentareLaden(projektId), NACHLADEN_MS, [projektId]);
  return projekt === projektId ? liste : [];
}

/** Kommentare zu einem Bezug (älteste zuerst). */
export function useKommentare(projektId: string, bezugTyp: BezugTyp, bezugId: string): Kommentar[] {
  return useAlleKommentare(projektId).filter((k) => k.bezugTyp === bezugTyp && k.bezugId === bezugId);
}

/** Anzahl der Kommentare je Schritt (für den Zähler im Diagramm). */
export function kommentareJeSchritt(alle: Kommentar[]): Record<string, number> {
  const z: Record<string, number> = {};
  for (const k of alle) if (k.bezugTyp === 'schritt') z[k.bezugId] = (z[k.bezugId] ?? 0) + 1;
  return z;
}
